/*global window*/
import { LocalStorage } from '../shared_critical/store';

(function (MOVE) {
  "use strict";

  var logger = function logger() {

    var levels = ['error', 'warn', 'info', 'debug'];

    var level = '';

    // Android native WebView doesnt support localStorage by defualt
    if (LocalStorage.isAvailable) {
      level = window.localStorage.getItem('loglevel') || '';
    }
    var level_id = levels.indexOf(level);

    function noop() {

    }

    function consoleLog(type) {
      if (level_id < levels.indexOf(type)) {
        return noop;
      }

      var console = window.console || {},
        logFn = console[type] || console.log || noop,
        hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) { /* empty */
      }

      if (hasApply) {
        return function () {
          return logFn.apply(console, arguments);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function (arg1, arg2) {
        logFn(arg1, arg2 === null ? '' : arg2);
      };
    }

    return {
      error: consoleLog('error'),
      warn: consoleLog('warn'),
      info: consoleLog('info'),
      debug: consoleLog('debug')
    };
  }();

  MOVE.logger = logger;
}(MOVE));

export const Logger = MOVE.logger;



// WEBPACK FOOTER //
// ./_core_framework/logger.js